import React, {
	useCallback,
	useState
} from 'react';
import PropTypes from 'prop-types';
import {
	useLocation,
	useHistory
} from 'react-router-dom';
import { FormRadio } from 'semantic-ui-react';

import {
	handleError,
	log
} from '../../../services/utils';

import { useUIAction } from '../../../contexts/UIContext';

import styles from '../auth.module.css';
import SubmitButton from '../SubmitButton';
import TextButton from '../../Shared/TextButton';
import { resendTwoAuthMethod } from '../../../api/nora/auth';
import Alert from '../../Alert';
import useToggle from '../../../hooks/useToggle';

const MethodForm = ( { setMethod } ) => {
	const history = useHistory();
	const { state: { otp, userID } } = useLocation();

	const { setScreenLoader } = useUIAction();

	const [ selection, setSelection ] = useState( 0 );
	const [ errorModal, toggleErrorModal ] = useToggle( false );
	const [ errorModalMessage, setErrorModalMessage ] = useState( '' );

	const mapOTPOptions = useCallback( () => otp.map( option => {
		const handleChange = ( e, { value } ) => setSelection( value );

		return ( <FormRadio
			checked={ selection === option.id }
			className={ styles.otpOption }
			key={ option.id }
			label={ `Send ${ option.label } to ${ option.value }` }
			onChange={ handleChange}
			value={ option.id }
		/>
		);
	} ), [
		selection,
		otp,
		setSelection
	] );

	const handleNext = useCallback( async () => {
		setScreenLoader( 'Processing...' );

		try {
			await resendTwoAuthMethod( userID, selection );

			setMethod( selection );
			setScreenLoader( '' );
		} catch ( error ) {
			setScreenLoader( '' );
			const errorMessage = handleError( error );

			setErrorModalMessage( errorMessage );
			toggleErrorModal();
		}
	}, [
		selection,
		setMethod,
		setScreenLoader,
		toggleErrorModal,
		userID
	] );

	const handleCancel = useCallback( () => {
		history.push( '/login' );
	}, [ history ] );

	return (
		<>
			{ log( 'methodForm' ) }
			<p className={ styles.methodFormMessage }>Select your desired method to recieve a<br/>one-time passcode to autheticate.</p>
			{ mapOTPOptions() }
			<SubmitButton
				buttonText="Next"
				disabled={ !selection }
				onSubmit={ handleNext }
			/>
			<TextButton
				buttonText="Cancel"
				className={ styles.textButton }
				onClick={ handleCancel }
			/>
			<Alert
				name="two-factor-error-alert"
				heading="Unable to Process Request"
				message={ errorModalMessage }
				open={ errorModal }
				closeModal={ toggleErrorModal }
				type="error"
			/>
		</>
	);
};

MethodForm.propTypes = { setMethod: PropTypes.func };

export default MethodForm;
